module.exports = __webpack_public_path__ + "static/ginger-0c5f03de43ba8161962b60edc84a921a.jpg";